module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "katalog-tiket-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/katalog-tiket'
      }
    }
  }, [_vm._v("List Katalog Tiket")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Katalog Tiket")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Katalog Tiket")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Katalog Tiket")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tipe")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.type),
      expression: "data.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Pilih Tipe Katalog --")]), _vm._v(" "), _vm._l((_vm.types), function(katalogType) {
    return _c('option', {
      key: katalogType.key,
      domProps: {
        "value": katalogType.key
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(katalogType.title) + "\n\t\t\t\t\t\t\t\t\t\t\t")])
  })], 2)])]), _vm._v(" "), (_vm.data.type) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.title),
      expression: "data.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._l((_vm.types), function(katalogType) {
    return (_vm.data.type === katalogType.key && katalogType.key !== 'DUEL' && katalogType.key !== 'CONSULTATION' && katalogType.key !== 'SCHEDULED_TRYOUT') ? _c('div', {
      key: katalogType.key,
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(katalogType.value) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 col-xs-12"
    }, [_c('vue-numeric', {
      staticClass: "form-control",
      attrs: {
        "separator": "."
      },
      model: {
        value: (_vm.data.value),
        callback: function($$v) {
          _vm.$set(_vm.data, "value", $$v)
        },
        expression: "data.value"
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.data.type === 'SCHEDULED_TRYOUT') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Apakah Langganan ?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.is_subscription),
      expression: "data.is_subscription"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.is_subscription) ? _vm._i(_vm.data.is_subscription, null) > -1 : (_vm.data.is_subscription)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.is_subscription,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "is_subscription", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "is_subscription", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "is_subscription", $$c)
        }
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.data.type === 'SCHEDULED_TRYOUT' && _vm.data.is_subscription) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bulan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "separator": "."
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tiket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "separator": "."
    },
    model: {
      value: (_vm.data.ticket),
      callback: function($$v) {
        _vm.$set(_vm.data, "ticket", $$v)
      },
      expression: "data.ticket"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.data.description),
      callback: function($$v) {
        _vm.$set(_vm.data, "description", $$v)
      },
      expression: "data.description"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.data.description) ? _c('span', [_c('i', [_vm._v("(" + _vm._s(_vm.characterCounter(_vm.data.description)) + " karakter)")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.data.picture) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.data.picture
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.handleChangePicture($event)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.status),
      expression: "data.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Pilih Status --")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.status.PUBLISH
    }
  }, [_vm._v("Publish")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.status.UNPUBLISH
    }
  }, [_vm._v("Unpublish")])])])])], 2) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.query.id && !_vm.$route.query.liveId) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Update")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Gambar"), _c('br'), _vm._v("(Max 1MB)")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20f77af0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pembayaran/KatalogTiketForm.vue
// module id = 1302
// module chunks = 0